import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "text-bold ellipsis",
  style: {"font-size":"12px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "q-pa-xs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col text-bold" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col text-caption" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col text-caption" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col text-caption" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col text-caption" }
const _hoisted_14 = {
  key: 0,
  class: "col q-pb-sm"
}
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "col q-pb-sm" }
const _hoisted_17 = { class: "col q-pb-sm" }
const _hoisted_18 = { class: "column" }
const _hoisted_19 = { class: "col q-pb-sm" }
const _hoisted_20 = { class: "column" }
const _hoisted_21 = {
  key: 0,
  class: "column"
}
const _hoisted_22 = { class: "col q-pb-sm" }
const _hoisted_23 = { class: "col q-pb-sm" }
const _hoisted_24 = {
  key: 1,
  class: "column"
}
const _hoisted_25 = { class: "q-gutter-md row items-start" }
const _hoisted_26 = { class: "q-gutter-md row items-start" }
const _hoisted_27 = { class: "column" }
const _hoisted_28 = { class: "col q-pb-sm" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = { class: "col q-pb-xs" }
const _hoisted_31 = { class: "col q-pb-xs" }
const _hoisted_32 = { class: "col q-pb-xs" }
const _hoisted_33 = { class: "column" }
const _hoisted_34 = { class: "col q-pb-sm" }
const _hoisted_35 = { class: "q-gutter-md row items-start" }
const _hoisted_36 = {
  key: 0,
  class: "q-pb-sm"
}
const _hoisted_37 = { class: "q-gutter-md row items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_SmsNotifications = _resolveComponent("SmsNotifications")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_AgmPicker = _resolveComponent("AgmPicker")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showPigProgressDialog)
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 0,
          modelValue: _ctx.showRunInfo,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showRunInfo) = $event)),
          seamless: "",
          position: "top",
          class: "pig-progress-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, {
              ref: _ctx.setCardEl,
              style: _normalizeStyle(_ctx.positionStyle),
              class: "pig-progress-card"
            }, {
              default: _withCtx(() => [
                (_ctx.minimized)
                  ? (_openBlock(), _createBlock(_component_q_card_section, {
                      key: 0,
                      class: "row items-center no-wrap q-pa-xs"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "directions_run",
                          size: "xs",
                          class: "q-mr-xs"
                        }),
                        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.toolName) + " on " + _toDisplayString(_ctx.pigRun.name), 1),
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "open_in_full",
                          size: "xs",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.minimized = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                _createTextVNode("Expand pig run info", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_q_card_section, {
                      key: 1,
                      horizontal: "",
                      class: "row items-center no-wrap q-pa-sm",
                      style: {"position":"relative"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "minimize",
                          size: "xs",
                          class: "pig-progress-minimize",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.minimized = true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                _createTextVNode("Minimize", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.showPigProgressDialog)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.toolName) + " on " + _toDisplayString(_ctx.pigRun.name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, " Launch Time (UTC): " + _toDisplayString(_ctx.launchDateFormatted), 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, " Expected Speed: " + _toDisplayString(_ctx.calculatedSpeedFormatted
                      ? _ctx.calculatedSpeedFormatted + ' mph'
                      : '0 mph'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, " Time To Next Track Marker: " + _toDisplayString(_ctx.etaNextFormated), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, " Time To Run Complete: " + _toDisplayString(_ctx.etaCompleteFormated), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showPigProgressDialog)
                          ? (_openBlock(), _createBlock(_component_q_space, { key: 1 }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          round: "",
                          icon: "more_vert",
                          disable: !_ctx.isOnline
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                _createTextVNode("Show Tools", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_q_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_list, { style: {"min-width":"150px"} }, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      clickable: "",
                                      onClick: _ctx.onZoomToPig
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                            _createTextVNode("Zoom to Pig", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])), [
                                      [_directive_close_popup]
                                    ]),
                                    (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: 0,
                                          clickable: "",
                                          onClick: _ctx.onNotifications
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                                _createTextVNode("Notifications", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      : _createCommentVNode("", true),
                                    (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: 1,
                                          clickable: "",
                                          onClick: _ctx.onAgmSelectList
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                                _createTextVNode("AGMs", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      : _createCommentVNode("", true),
                                    (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: 2,
                                          clickable: "",
                                          onClick: _ctx.onEditLaunchTime
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                                _createTextVNode("Edit Launch Time", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      : _createCommentVNode("", true),
                                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      clickable: "",
                                      onClick: _ctx.onAddAGMMarker
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                            _createTextVNode("Add Marker", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])), [
                                      [_directive_close_popup]
                                    ]),
                                    (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: 3,
                                          clickable: "",
                                          onClick: _ctx.onCancelRun
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                                _createTextVNode("Cancel Run", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      : _createCommentVNode("", true),
                                    (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          key: 4,
                                          clickable: "",
                                          onClick: _ctx.onPigRunEndPressed
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                                _createTextVNode("End/Save Run", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"])
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addPassageDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addPassageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add Passage", -1)),
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.closeManualPsg
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    (_ctx.showErrorMsg)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_q_badge, {
                            class: "q-ml-sm",
                            color: "red"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.ManualPsg_ErrorMsg), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.passageMarker,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passageMarker) = $event)),
                          dense: "",
                          color: "blue-brand",
                          outlined: "",
                          options: _ctx.pigRunMarkerNames,
                          label: "AGM Marker"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.passageTimestamp,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Passage Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.passageTimestamp,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.passageTimestamp,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passageTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": "",
                          onClick: _ctx.closeManualPsg
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Add",
                          type: "button",
                          disabled: !_ctx.passageMarker,
                          "no-caps": "",
                          onClick: _ctx.onAddPassageInfo
                        }, null, 8, ["disabled", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showMissedPassages,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showMissedPassages) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"630px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                    _createTextVNode("Unassociated Passages", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            (_ctx.missedPassages && _ctx.missedPassages.length)
              ? (_openBlock(), _createBlock(_component_q_table, {
                  key: 0,
                  pagination: _ctx.passagePagination,
                  "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.passagePagination) = $event)),
                  "table-header-class": "bg-blue-brand text-white",
                  rows: _ctx.missedPassages,
                  columns: _ctx.missedPassageColumns,
                  "row-key": "name",
                  dense: ""
                }, {
                  "body-cell-graph-data": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        (props.row.elfId)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              dense: "",
                              icon: "show_chart",
                              label: "ELF",
                              onClick: ($event: any) => (_ctx.onShowChart(props, 'ELF'))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (props.row.geoId)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              dense: "",
                              icon: "show_chart",
                              label: "GEO",
                              onClick: ($event: any) => (_ctx.onShowChart(props, 'GEO'))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (props.row.magId)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 2,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              dense: "",
                              icon: "show_chart",
                              label: "MAG",
                              onClick: ($event: any) => (_ctx.onShowChart(props, 'MAG'))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  "body-cell-add-data": _withCtx((props) => [
                    _createVNode(_component_q_td, { props: props }, {
                      default: _withCtx(() => [
                        (
                  props.row.passageId &&
                  (_ctx.getuser() == 'admin' || _ctx.getuser() == 'superadmin')
                )
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              size: "sm",
                              class: "q-mr-xs btn-brand",
                              icon: "fas fa-plus",
                              label: "Add to Marker",
                              dense: "",
                              onClick: ($event: any) => (_ctx.onAddMissedPassage(props.row))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["pagination", "rows", "columns"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.cancelConfirmDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cancelConfirmDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"250px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                    _createTextVNode("Cancel Pig Run", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "column" }, [
                  _createElementVNode("div", { class: "col q-pb-sm" }, "Are you sure you want to cancel?")
                ], -1)),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "No",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Yes-Cancel",
                      "no-caps": "",
                      onClick: _ctx.onCancelConfirm
                    }, null, 8, ["onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.deleteConfirmDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.deleteConfirmDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                    _createTextVNode("Delete Passage", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "column" }, [
                  _createElementVNode("div", { class: "col q-pb-sm" }, " Are you sure you want to delete this passage? ")
                ], -1)),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "No",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Yes",
                      "no-caps": "",
                      onClick: _ctx.onDeleteManualPassage
                    }, null, 8, ["onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.editConfirmDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editConfirmDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                    _createTextVNode("Edit Manual Passage", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.closeManualPsg
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.EditManual_ErrorMsg)
                  ? (_openBlock(), _createBlock(_component_q_form, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, {
                          class: "q-ml-sm",
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.ManualPsg_ErrorMsg), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.EditManualPsgTimestamp,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.EditManualPsgTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Passage Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.EditManualPsgTimestamp,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.EditManualPsgTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.EditManualPsgTimestamp,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.EditManualPsgTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": "",
                          onClick: _ctx.closeManualPsg
                        }, null, 8, ["onClick"]), [
                          [_directive_close_popup]
                        ]),
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Set",
                          type: "button",
                          "no-caps": "",
                          onClick: _ctx.onEditManualPsg
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addNoteDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addNoteDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"250px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                    _createTextVNode("Add Note", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("form", null, [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.noteText,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.noteText) = $event)),
                      filled: "",
                      type: "textarea",
                      autogrow: "",
                      autofocus: "",
                      dense: "",
                      rules: [
                  (val) =>
                    val.length <= 200 || 'Notes are limited to 200 characters',
                ]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_actions, { align: "center" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_q_btn, {
                        disable: _ctx.noteText.length > 200,
                        class: "btn-brand",
                        label: "Save",
                        "no-caps": "",
                        onClick: _ctx.onSaveNote
                      }, null, 8, ["disable", "onClick"]), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.assignUidDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.assignUidDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"300px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                    _createTextVNode("Assign UID", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    (_ctx.availableUids.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _cache[69] || (_cache[69] = _createTextVNode(" Link marker ", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.selectedMarkerName), 1),
                            _cache[70] || (_cache[70] = _createTextVNode(" to AGM Device UID ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_q_select, {
                              modelValue: _ctx.selectedUid,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedUid) = $event)),
                              dense: "",
                              color: "blue-brand",
                              autofocus: "",
                              outlined: "",
                              options: _ctx.availableUids,
                              label: "AGM Device UID"
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, " No AGMs have been assigned to this pig run ")),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": ""
                        }, null, 512), [
                          [_directive_close_popup]
                        ]),
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Link",
                          type: "button",
                          disabled: !_ctx.selectedUid,
                          "no-caps": "",
                          onClick: _ctx.onSaveUidLink
                        }, null, 8, ["disabled", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.changeNotificationsDialog,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.changeNotificationsDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"300px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                    _createTextVNode("Notifications", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_SmsNotifications, {
                  markers: _ctx.pigRun ? _ctx.pigRun.markers : [],
                  notifications: _ctx.userNotifications,
                  onUpdateNotifications: _ctx.onUpdateNotifications
                }, null, 8, ["markers", "notifications", "onUpdateNotifications"]),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Cancel",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Save",
                      type: "button",
                      "no-caps": "",
                      onClick: _ctx.onSaveUserNotifications
                    }, null, 8, ["onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.changeSpeedDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.changeSpeedDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"300px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                    _createTextVNode("Edit Tool Speed", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_separator),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.newSpeed,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newSpeed) = $event)),
                      dense: "",
                      outlined: "",
                      color: "blue-brand",
                      step: "0.5",
                      min: "0",
                      "max-decimals": "2",
                      type: "number",
                      label: _ctx.SpeedDesc,
                      style: {"max-width":"200px","width":"100px","height":"30px"}
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_q_btn_dropdown, {
                      "no-caps": "",
                      size: "12px",
                      color: "grey-9",
                      label: _ctx.SpeedUnits,
                      style: {"width":"70px","height":"30px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onSpeedUnitsSelect(1)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, null, {
                                      default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                        _createTextVNode("m/s", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })), [
                              [_directive_close_popup]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onSpeedUnitsSelect(2)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, null, {
                                      default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                        _createTextVNode("mph", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Cancel",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Save",
                      type: "button",
                      "no-caps": "",
                      onClick: _ctx.onSaveNewSpeed
                    }, null, 8, ["onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addAgmsDialog,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.addAgmsDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"620px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                    _createTextVNode("Edit Available AGMs", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_AgmPicker, {
                  "available-agms": _ctx.agmAvailableList,
                  "selected-agms": _ctx.agmSelectedList,
                  "onUpdate:availableAgms": _cache[25] || (_cache[25] = ($event: any) => (_ctx.agmAvailableList = $event)),
                  "onUpdate:selectedAgms": _cache[26] || (_cache[26] = ($event: any) => (_ctx.agmSelectedList = $event))
                }, null, 8, ["available-agms", "selected-agms"]),
                _createVNode(_component_q_separator, { class: "q-mt-md" }),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Cancel",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Save",
                      "no-caps": "",
                      onClick: _ctx.onAgmListChanged
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.endPigRunDialog,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.endPigRunDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[76] || (_cache[76] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add Receive Time", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.ReceiveTimestamp,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.ReceiveTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Receive Time (UTC)",
                          rules: [(val) => _ctx.ValidateReceiveTime(val)]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.ReceiveTimestamp,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.ReceiveTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.ReceiveTimestamp,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.ReceiveTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": ""
                        }, null, 512), [
                          [_directive_close_popup]
                        ]),
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Add",
                          type: "button",
                          "no-caps": "",
                          onClick: _ctx.onEndRunConfirmPressed
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.endPigRunConfirmDialog,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.endPigRunConfirmDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                    _createTextVNode("Confirm End Run", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[78] || (_cache[78] = _createElementVNode("b", null, "Run:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.pigRun.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[79] || (_cache[79] = _createElementVNode("b", null, "Launch (UTC):", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.launchDateFormatted), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[80] || (_cache[80] = _createElementVNode("b", null, "Receive (UTC):", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.ReceiveTimestamp), 1)
                  ])
                ]),
                _createVNode(_component_q_separator, { class: "q-mt-sm" }),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Cancel",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "End/Save",
                      "no-caps": "",
                      onClick: _ctx.onEndRun
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.Launch_at_TimeDialog,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.Launch_at_TimeDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"450px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                    _createTextVNode("Edit Launch Time", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.ErrorMsg)
                  ? (_openBlock(), _createBlock(_component_q_form, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, {
                          class: "q-ml-sm",
                          color: "red"
                        }, {
                          default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                            _createTextVNode("Error ! Launch cannot be set to future time.", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.LaunchTimestamp,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Launch Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.LaunchTimestamp,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.LaunchTimestamp,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Cancel",
                          "no-caps": ""
                        }, null, 512), [
                          [_directive_close_popup]
                        ]),
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Save",
                          type: "button",
                          "no-caps": "",
                          onClick: _ctx.onSaveLaunchTime
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.EditPigDialog,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.EditPigDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"450px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                    _createTextVNode("Edit Pig Info", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  ref: "Speed_Validation",
                  modelValue: _ctx.tempMarker_Speed,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.tempMarker_Speed) = $event)),
                  dense: "",
                  color: "blue-brand",
                  type: "number",
                  outlined: "",
                  label: "Expected Speed (mph)",
                  rules: [
              (val) =>
                (val && val.length > 0) ||
                'Expected speed required to update Pig Location',
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.tempMarker_lat,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.tempMarker_lat) = $event)),
                    dense: "",
                    color: "blue-brand",
                    type: "number",
                    outlined: "",
                    label: "Pig New Lat",
                    disable: true,
                    rules: [
                (val) =>
                  (val && val.length > 0) || 'Valid Lat value is required',
              ]
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.tempMarker_lon,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.tempMarker_lon) = $event)),
                    dense: "",
                    color: "blue-brand",
                    type: "number",
                    outlined: "",
                    label: "Pig New Lon",
                    disable: true,
                    rules: [
                (val) =>
                  (val && val.length > 0) || 'Valid Lon value is required',
              ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "center" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Cancel",
                  onClick: _ctx.onCancelEditSpeed
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Save",
                  onClick: _ctx.onEditRunSpeed
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.addMarkerDialog,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.addMarkerDialog) = $event)),
      seamless: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                    _createTextVNode("Marker Configuration", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.onCloseNewMarkerSetup
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.newMarkerError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_q_badge, { color: "red" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.newMarkerError), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_input, {
                  modelValue: _ctx.newMarkerName,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.newMarkerName) = $event)),
                  filled: "",
                  type: "textarea",
                  autogrow: "",
                  autofocus: "",
                  dense: "",
                  label: "Marker Name",
                  rules: [
              (val) =>
                val.length <= 20 || 'Marker Name is limited to 20 characters',
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.newMarker_lat,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.newMarker_lat) = $event)),
                    dense: "",
                    color: "blue-brand",
                    type: "number",
                    outlined: "",
                    label: "Pig New Lat",
                    disable: true,
                    rules: [
                (val) =>
                  (val && val.length > 0) || 'Valid Lat value is required',
              ]
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.newMarker_lon,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.newMarker_lon) = $event)),
                    dense: "",
                    color: "blue-brand",
                    type: "number",
                    outlined: "",
                    label: "Pig New Lon",
                    disable: true,
                    rules: [
                (val) =>
                  (val && val.length > 0) || 'Valid Lon value is required',
              ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _cache[85] || (_cache[85] = _createElementVNode("div", { class: "text-subtitle2 q-mb-xs" }, "Link Device", -1)),
                _createVNode(_component_q_select, {
                  modelValue: _ctx.selectedDeviceUid,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.selectedDeviceUid) = $event)),
                  options: _ctx.availableDevicesForMarker,
                  label: "Select a device",
                  "emit-value": "",
                  "map-options": "",
                  dense: "",
                  outlined: "",
                  color: "blue-brand",
                  loading: _ctx.loadingAvailableDevices,
                  rules: [(val) => val != null || 'A device is required.']
                }, null, 8, ["modelValue", "options", "loading", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Save",
                  onClick: _ctx.onSaveNewMarker
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showWaveformSelectionDialog,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.showWaveformSelectionDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"300px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                _createElementVNode("div", { class: "text-h6" }, "Select Waveform to Verify", -1),
                _createElementVNode("div", { class: "text-body2 q-mt-sm" }, " Choose which waveform type to verify for this passage. ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_option_group, {
                  modelValue: _ctx.selectedWaveformId,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.selectedWaveformId) = $event)),
                  options: _ctx.waveformOptionsForVerify,
                  type: "radio"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Cancel",
                  class: "btn-brand",
                  onClick: _ctx.onCancelWaveformSelection
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Confirm",
                  class: "btn-brand",
                  color: "primary",
                  disable: _ctx.selectedWaveformId === null,
                  onClick: _ctx.onConfirmWaveformSelection
                }, null, 8, ["disable", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showAddMarkerInstructions,
      "onUpdate:modelValue": [
        _cache[48] || (_cache[48] = ($event: any) => ((_ctx.showAddMarkerInstructions) = $event)),
        _cache[49] || (_cache[49] = 
        (val) => {
          if (!val) _ctx.onCancelAddMarker();
        }
      )
      ],
      title: "Add Marker",
      icon: "ads_click",
      message: "Select a point on the map where you want to add a marker to this pig run.",
      tip: "Tip: Select a point on the pipeline to ensure the marker accurately reflects your pig run."
    }, null, 8, ["modelValue"])
  ]))
}